import { createAction, props } from "@ngrx/store";
import IUser from "@skills-app/models/user";

const prefix = "[User API]";

export const requestUsers = createAction(`${prefix} Get Users`);

export const requestFilteredUsers = createAction(
  `${prefix} Request Filtered Users With Current Conditions`,
);

export const requestFilterUsers = createAction(
  `${prefix} Request Filter User`,
  props<{ searchTerm: string }>(),
);

export const requestFilterUserSuccess = createAction(
  `${prefix} Request Filter User Success`,
  props<{ users: IUser[] }>(),
);

export const requestFilterUserError = createAction(
  `${prefix} Request Filter User Error`,
);
